export default "__VITE_ASSET__CXVWvbYK__"